import React from 'react'

const ErrorPage = () =>
  <div className="maxWidth">
    <p>Page not found</p>
  </div>

export default ErrorPage